import cookie from 'react-cookies';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { airPayoutJourneysApi } from 'api';
import { TURNSTILE_COOKIE } from 'config/cookies';
import { resetTurnstileToken } from 'utils/turnstile';
import { Journey, JourneyWithMeta } from '@airhelp/plus';
import {
  useAirPayoutJourneys,
  useJourney,
  useJourneys,
} from '@airhelp/plus/react';
import { setVeriffUrl } from 'utils/veriff';

const triggerAirPayoutForJourney = async (
  journeyId: number,
  payload: airPayoutJourneysApi.AirPayoutRequest,
) => {
  const token = cookie.load(TURNSTILE_COOKIE);
  const [error, response] =
    await airPayoutJourneysApi.triggerAirPayoutForJourneys(
      journeyId,
      payload,
      token,
    );

  if (error) {
    throw error;
  }

  resetTurnstileToken();

  return response;
};

const useTriggerAirPayoutJourney = () => {
  const queryClient = useQueryClient();
  const requestAirPayoutMutation = useMutation({
    mutationFn: (params: {
      journeyData: Journey;
      params: airPayoutJourneysApi.AirPayoutRequest;
    }) => triggerAirPayoutForJourney(params.journeyData.id, params.params),

    // TODO cleanip  after flag removed
    onSuccess: (data: JourneyWithMeta | Journey, params) => {
      const journey: Journey = (data as JourneyWithMeta).journey || data;

      queryClient.invalidateQueries({
        queryKey: useJourneys.getQueryKey(),
      });

      queryClient.invalidateQueries({
        queryKey: useAirPayoutJourneys.getQueryKey({
          params: { journeyId: journey.id },
        }),
      });

      queryClient.setQueryData(
        useJourney.getQueryKey({ params: { id: journey.id } }),
        { ...journey, computed: params.journeyData.computed },
      );

      if ('meta' in data) {
        const airRequestId = data.meta.airRequestId as string;
        setVeriffUrl(journey.id, data.meta.sessionUrl, airRequestId);
      }
    },
  });
  return requestAirPayoutMutation;
};

export default useTriggerAirPayoutJourney;
